import { apiClient } from '@/api/api'
import type {
  CapsuleSurveyBlocksBody,
  CapsuleSurveyBlocksResponse,
  CapsuleSurveyConfigResponse,
  CapsuleSurveySubmitBody,
  CapsuleSurveySubmitResponse,
} from './types'

/**
 * How long the wizard waits for the blocks before it shows the error state. The designer left the
 * number to agree with the backend ("If ML does not answer in N seconds the error state is shown");
 * 20 s matches the stylist timeout the canvas already uses.
 */
export const CAPSULE_SURVEY_BLOCKS_TIMEOUT_MS = 20_000

export const CAPSULE_SURVEY_CONFIG_ID = 'default-playground-capsule-create'

/** The one `/playground/*` route without a JWT. */
export const getCapsuleSurveyConfig = async (configId = CAPSULE_SURVEY_CONFIG_ID) => {
  return apiClient.get<CapsuleSurveyConfigResponse>('/playground/capsule-survey/config', {
    params: { config_id: configId },
  })
}

export const submitCapsuleSurvey = async (body: CapsuleSurveySubmitBody) => {
  return apiClient.post<CapsuleSurveySubmitResponse>('/playground/capsule-survey/submit', body)
}

/**
 * §10.5a — the detail blocks for the picked theme (or the shopper's free text). Behind the
 * `capsule_survey_blocks` capability; without it the wizard keeps reading the static
 * `branches{}` of the config.
 */
export const getCapsuleSurveyBlocks = async (body: CapsuleSurveyBlocksBody) => {
  return apiClient.post<CapsuleSurveyBlocksResponse>('/playground/capsule-survey/blocks', body, {
    timeout: CAPSULE_SURVEY_BLOCKS_TIMEOUT_MS,
  })
}
